import React from 'react';
import type { FC, ReactNode } from 'react';
import { match, constant } from 'variant';
import {
  ErrorIcon,
  WarningIcon,
  SuccessIcon,
  InsightIcon,
} from '../icons/index.js';
import { Text } from './Text.js';

export type AlertType = 'error' | 'warning' | 'success' | 'insight';

export interface AlertProps {
  type: AlertType;
  children: ReactNode;
}

export const Alert: FC<AlertProps> = ({ type, children }) => {
  const icon = match(type, {
    error: constant(
      <Text skin="error">
        <ErrorIcon />
      </Text>
    ),
    warning: constant(
      <Text skin="warning">
        <WarningIcon />
      </Text>
    ),
    success: constant(
      <Text skin="success">
        <SuccessIcon />
      </Text>
    ),
    insight: constant(<InsightIcon />),
  });

  return (
    <Text>
      {icon} {children}
    </Text>
  );
};
